import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { AnyObject } from '@mri/types';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class MessageNotifyInterceptor implements HttpInterceptor {

  constructor(
    private _snackBar: MatSnackBar
  ) {

  }

  intercept(req: HttpRequest<AnyObject>, next: HttpHandler): Observable<HttpEvent<AnyObject>> {
    // Aquí puedes inspeccionar o modificar la solicitud antes de enviarla al servidor
    // También puedes manipular la respuesta antes de que llegue a la aplicación

    return next.handle(req)
      .pipe(
        tap(response => {
          const { body } = (response as AnyObject) || {};

          if (['PUT', 'POST', 'DELETE'].includes(req.method) && body?.message) {
            /*this._snackBar.open(body?.message, '', {
              panelClass: ['bg-success-500'],
              horizontalPosition: 'end',
              verticalPosition: 'top',
              duration: 5000
            });*/
          }
        })
      );
  }


}

